var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.69313 2.07031H2.07026C1.79573 2.07031 1.53245 2.17937 1.33833 2.37349C1.14421 2.56761 1.03516 2.83089 1.03516 3.10542V10.3512C1.03516 10.6257 1.14421 10.889 1.33833 11.0831C1.53245 11.2772 1.79573 11.3863 2.07026 11.3863H9.316C9.59053 11.3863 9.85381 11.2772 10.0479 11.0831C10.242 10.889 10.3511 10.6257 10.3511 10.3512V6.72829",
    stroke: "#BEBEBE",
    strokeWidth: 1.03511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57468 1.29398C9.78058 1.08808 10.0598 0.972412 10.351 0.972412C10.6422 0.972412 10.9214 1.08808 11.1273 1.29398C11.3332 1.49987 11.4489 1.77913 11.4489 2.07031C11.4489 2.36149 11.3332 2.64074 11.1273 2.84664L6.21059 7.76339L4.14038 8.28094L4.65793 6.21073L9.57468 1.29398Z",
    stroke: "#BEBEBE",
    strokeWidth: 1.03511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.c7bce2843e2ceda53dd86662f4644cbc.svg";
export { ForwardRef as ReactComponent };